import { render } from "./FileListWithThumbnail.vue?vue&type=template&id=1fcfc694"
import script from "./FileListWithThumbnail.vue?vue&type=script&lang=js"
export * from "./FileListWithThumbnail.vue?vue&type=script&lang=js"
script.render = render

export default script